<div id="vision" class="mb-4">
    <div class="container-fluid px-0">
        <div class="row">
            <div class="col-12 col-md-6 box box1 px-md-5">
                <h2 class="home-title text-center">Vision</h2>
                <p class="mb-0">The vision of Institute is to develop Into a center of Excellence for Technical, Professional, Legal and Management Education at the Graduate and Post Graduate levels.</p>
            </div>
            <div class="col-12 col-md-6 box box2 px-md-5">
                <h2 class="home-title text-center">Mission</h2>
                <p class="mb-0">The mission of the society is to so shape the Institute as it acquires the status of acclaimed center of learning-an abode of excellence in Technical, Legal, Management and Professional Education.</p>
            </div>
        </div>
    </div>
</div>
